import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Billboard } from '@instructure/ui-billboard';
import { Pagination, PaginationButton } from '@instructure/ui-pagination';
import { Text } from '@instructure/ui-text';
import { Avatar } from '@instructure/ui-avatar';
import { Spinner } from '@instructure/ui-spinner';
import { IconOutcomesLine } from '@instructure/ui-icons';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import shortid from 'shortid';
import t from 'format-message';
import _ from 'lodash';
import ExportCSVButton from "./ExportCSVButton/index.js";
import Header from "./Header/index.js";
import HeaderDetails from "./HeaderDetails/index.js";
import Score from "./Score/index.js";
var Early = function Early(props) {
  return jsx("svg", Object.assign({
    width: "138",
    height: "88",
    viewBox: "0 0 138 88",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("title", null, "Early-Graphic"), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("path", {
    d: "M136.728 34.855c0-6.158-5.547-7.973-5.547-7.973s5.547-1.544 5.547-7.702c0-6.159-5.547-7.9-5.547-7.9H18.854v50.618h53.39v2.08c0 4.176 2.643 7.726 6.344 9.095l25.62 13.842s6.495 1.48 9.88-4.789c1.856-3.434 1.287-6.43.395-8.442l16.698.038s5.547-1.543 5.547-7.701c0-6.16-5.547-7.974-5.547-7.974s5.547-1.543 5.547-7.701c0-5.554-4.498-7.51-5.385-7.842.887-.3 5.385-2.094 5.385-7.648",
    fill: "#FED2B8"
  }), jsx("path", {
    d: "M136.728 34.855c0-6.158-5.547-7.973-5.547-7.973s5.547-1.544 5.547-7.702c0-6.159-5.547-7.9-5.547-7.9H18.854v50.618h53.39v2.08c0 4.176 2.643 7.726 6.344 9.095l25.62 13.842s6.495 1.48 9.88-4.789c1.856-3.434 1.287-6.43.395-8.442l16.698.038s5.547-1.543 5.547-7.701c0-6.16-5.547-7.974-5.547-7.974s5.547-1.543 5.547-7.701c0-5.554-4.498-7.51-5.385-7.842.887-.3 5.385-2.094 5.385-7.648z",
    stroke: "#FD6A11",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M65.217 65.244H41.83a2 2 0 0 1-2-2V10.627a2 2 0 0 1 2-2h23.388a2 2 0 0 1 2 2v52.617a2 2 0 0 1-2 2",
    fill: "#75848F"
  }), jsx("path", {
    d: "M65.217 65.244H41.83a2 2 0 0 1-2-2V10.627a2 2 0 0 1 2-2h23.388a2 2 0 0 1 2 2v52.617a2 2 0 0 1-2 2z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M26.388 65.244H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h23.388a2 2 0 0 1 2 2v60.244a2 2 0 0 1-2 2",
    fill: "#F4F5F6"
  }), jsx("path", {
    d: "M26.388 65.244H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h23.388a2 2 0 0 1 2 2v60.244a2 2 0 0 1-2 2z",
    stroke: "#778690",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M72.244 36.242c0 10.34-8.382 18.721-18.721 18.721-10.34 0-18.721-8.382-18.721-18.72 0-10.34 8.381-18.722 18.721-18.722 10.339 0 18.721 8.382 18.721 18.721",
    fill: "#75848F"
  }), jsx("path", {
    d: "M72.244 36.242c0 10.34-8.382 18.721-18.721 18.721-10.34 0-18.721-8.382-18.721-18.72 0-10.34 8.381-18.722 18.721-18.722 10.339 0 18.721 8.382 18.721 18.721z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M69.124 36.242c0 8.616-6.985 15.601-15.601 15.601s-15.601-6.985-15.601-15.6c0-8.617 6.985-15.602 15.6-15.602 8.617 0 15.602 6.985 15.602 15.601",
    fill: "#FFF"
  }), jsx("path", {
    d: "M69.124 36.242c0 8.616-6.985 15.601-15.601 15.601s-15.601-6.985-15.601-15.6c0-8.617 6.985-15.602 15.6-15.602 8.617 0 15.602 6.985 15.602 15.601z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M53.523 20.642v4.252M53.523 47.59v4.253M37.922 36.242h4.252M64.871 36.242h4.252",
    stroke: "#3F5463",
    strokeWidth: "3"
  }), jsx("path", {
    d: "M48.67 24.975l4.853 11.267M59.764 41.55l-6.242-5.308",
    stroke: "#3F5463",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M59.07 47.337l-5.547-11.095",
    stroke: "#F1070F",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M56.296 36.242a2.773 2.773 0 1 1-5.546 0 2.773 2.773 0 0 1 5.546 0",
    fill: "#96A0A8"
  }), jsx("path", {
    d: "M56.296 36.242a2.773 2.773 0 1 1-5.546 0 2.773 2.773 0 0 1 5.546 0z",
    stroke: "#3F5463",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M18.854 10.01a4.277 4.277 0 1 1-8.553-.002 4.277 4.277 0 0 1 8.553.002",
    fill: "#FFF"
  }), jsx("path", {
    d: "M18.854 10.01a4.277 4.277 0 1 1-8.553-.002 4.277 4.277 0 0 1 8.553.002z",
    stroke: "#778690",
    strokeWidth: "2"
  }), jsx("path", {
    d: "M114.483 73.685h-9.318",
    stroke: "#FD6A11",
    strokeWidth: "2",
    strokeLinecap: "round"
  })));
};
var NoReport = function NoReport(props) {
  return jsx("svg", Object.assign({
    width: "70",
    height: "96",
    viewBox: "0 0 70 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("title", null, "Page 1"), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("path", {
    d: "M65 95H5a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4h60a4 4 0 0 1 4 4v69a4 4 0 0 1-4 4z",
    fill: "#F6F7F6"
  }), jsx("path", {
    d: "M5 19c-1.654 0-3 1.346-3 3v69c0 1.654 1.346 3 3 3h60c1.654 0 3-1.346 3-3V22c0-1.654-1.346-3-3-3H5zm60 77H5c-2.757 0-5-2.243-5-5V22c0-2.757 2.243-5 5-5h60c2.757 0 5 2.243 5 5v69c0 2.757-2.243 5-5 5z",
    fill: "#3F5463"
  }), jsx("path", {
    d: "M0 96h70V0H0z"
  }), jsx("path", {
    fill: "#FFF",
    d: "M7 89h56.5V24.213H7z"
  }), jsx("path", {
    fill: "#6F7F8A",
    d: "M9 90H6v-3h2v1h1zM6 34.317h2v-4.053H6v4.053zm0 8.106h2V38.37H6v4.053zm0 8.104h2v-4.053H6v4.053zm0 8.106h2V54.58H6v4.053zm0 8.104h2v-4.053H6v4.053zm0 8.106h2V70.79H6v4.053zm0 8.104h2v-4.053H6v4.053zM8 26.213H6v-3h3v2H8zM13.038 25.213h4.039v-2h-4.039v2zm8.078 0h4.038v-2h-4.038v2zm8.076 0h4.039v-2h-4.039v2zm8.078 0h4.038v-2H37.27v2zm8.076 0h4.039v-2h-4.039v2zm8.077 0h4.038v-2h-4.038v2zM64.5 26.213h-2v-1h-1v-2h3zM62.5 34.318h2v-4.053h-2v4.053zm0 8.105h2V38.37h-2v4.053zm0 8.105h2v-4.053h-2v4.053zm0 8.105h2V54.58h-2v4.053zm0 8.105h2v-4.053h-2v4.053zm0 8.105h2V70.79h-2v4.053zm0 8.105h2v-4.053h-2v4.053zM64.5 90h-3v-2h1v-1h2zM13.039 90h4.038v-2h-4.038v2zm8.076 0h4.039v-2h-4.039v2zm8.077 0h4.038v-2h-4.038v2zm8.077 0h4.039v-2h-4.039v2zm8.077 0h4.038v-2h-4.038v2zm8.076 0h4.039v-2h-4.039v2z"
  }), jsx("path", {
    d: "M55.874 25H14.126a2 2 0 0 1-1.816-2.838L17 12h36l4.69 10.162A2 2 0 0 1 55.874 25",
    fill: "#C0C6CB"
  }), jsx("path", {
    d: "M35 1C24 1 24 12 24 12h22S44.667 1 35 1",
    fill: "#E5E7E9"
  }), jsx("path", {
    d: "M56.717 23.54a.983.983 0 0 1-.843.46H14.126a.984.984 0 0 1-.843-.46.983.983 0 0 1-.065-.959l4.422-9.58H52.36l4.42 9.58a.983.983 0 0 1-.064.958M35 2c6.999 0 9.19 6.354 9.799 9H25.07c.298-2.546 1.852-9 9.929-9m23.598 19.743L53.64 11h-6.807C46.242 8.252 43.74 0 35 0c-9.812 0-11.6 8.122-11.926 11H16.36l-4.958 10.743a2.984 2.984 0 0 0 .196 2.874A2.99 2.99 0 0 0 14.126 26h41.748a2.991 2.991 0 0 0 2.528-1.383c.554-.866.627-1.94.196-2.874",
    fill: "#3F5463"
  }), jsx("path", {
    d: "M34.666 4.551a2 2 0 1 0 .002 4.002 2 2 0 0 0-.002-4.002",
    fill: "#3F5463"
  }), jsx("path", {
    d: "M30.907 46.59a4.568 4.568 0 1 0-9.137.002 4.568 4.568 0 0 0 9.137-.001M44.339 42.023a4.568 4.568 0 1 0 0 9.136 4.568 4.568 0 0 0 0-9.136M43.5 65.894H27a2 2 0 0 0 0 4h16.5a2 2 0 0 0 0-4",
    fill: "#6F7F8A"
  })));
};
import { REPORT_DOWNLOAD_FF } from "../../constants.js";
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
var renderBillboard = function renderBillboard(args, _foo) {
  var boardProps = Object.assign({
    headingLevel: 'h3',
    size: 'small',
    margin: 'medium'
  }, args);
  return jsx(Billboard, boardProps);
};
var renderLoading = function renderLoading(styles) {
  return jsx("div", {
    css: styles.loadingSpinner
  }, jsx(Spinner, {
    renderTitle: t('Loading')
  }));
};
var noOutcomes = function noOutcomes() {
  return {
    heading: t('There is no report here to show'),
    message: t('The assessment has no outcomes aligned to it. Go to the Build tab to align outcomes.'),
    hero: jsx("span", {
      "aria-hidden": "true"
    }, jsx(NoReport, null))
  };
};
var noStudents = function noStudents() {
  return {
    heading: t("Looks like you're a little early"),
    message: t('Students must finish the assessment before any outcome results will show here. ' + 'Check back here after some students have completed the assessment.'),
    hero: jsx(Early, null)
  };
};
var renderCorner = function renderCorner(count, styles) {
  var text = t("{\n    count, plural,\n        one {1 Outcome Aligned}\n      other {# Outcomes Aligned}\n  }", {
    count: count
  });
  return jsx("div", {
    css: styles.corner,
    role: "columnheader",
    "data-automation": "outcomesPerStudent__corner"
  }, jsx(IconOutcomesLine, null), jsx(Text, {
    size: "small"
  }, text));
};
var renderStudentName = function renderStudentName(student, styles) {
  var studentNameId = shortid.generate();
  var studentNameElement = jsx("div", {
    css: styles.studentName,
    id: studentNameId,
    role: "rowheader"
  }, jsx(PresentationContent, null, jsx("span", {
    css: styles.avatar,
    "data-automation": "outcomesPerStudent__avatar"
  }, jsx(Avatar, {
    size: "small",
    name: student.full_name,
    src: student.avatar_url
  }))), jsx("span", {
    css: styles.name,
    "data-automation": "outcomesPerStudent__name"
  }, jsx(Text, {
    size: "small"
  }, student.full_name)));
  return {
    studentNameId: studentNameId,
    studentNameElement: studentNameElement
  };
};
var renderPagination = function renderPagination(_ref) {
  var artifactType = _ref.artifactType,
    artifactId = _ref.artifactId,
    currentPage = _ref.currentPage,
    pageCount = _ref.pageCount,
    loadPage = _ref.loadPage,
    loadUsersOverride = _ref.loadUsersOverride;
  if (currentPage !== null) {
    return jsx(Pagination, {
      margin: "small",
      variant: "compact",
      labelNext: t('Next Page'),
      labelPrev: t('Previous Page')
    }, _.range(1, pageCount + 1).map(function (pageNumber) {
      var current = pageNumber === currentPage;
      var changePage = function changePage() {
        return loadPage(artifactType, artifactId, pageNumber, loadUsersOverride);
      };
      return jsx(PaginationButton, {
        current: current,
        key: pageNumber,
        onClick: changePage
      }, pageNumber);
    }));
  }
};
// eslint-disable-next-line immutable/no-mutation
renderPagination.propTypes = {
  artifactType: PropTypes.string.isRequired,
  artifactId: PropTypes.string.isRequired,
  pageCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  loadPage: PropTypes.func.isRequired,
  loadUsersOverride: PropTypes.func
};
renderPagination.defaultProps = {
  loadUsersOverride: void 0
};
var OutcomesPerStudentReport = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomesPerStudentReport, _React$Component);
  var _super = _createSuper(OutcomesPerStudentReport);
  function OutcomesPerStudentReport() {
    var _this;
    _classCallCheck(this, OutcomesPerStudentReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderExportButton = function (hasAnyStudents, focusedElement) {
      var _this$props = _this.props,
        hasAnyOutcomes = _this$props.hasAnyOutcomes,
        loading = _this$props.loading,
        loadUsersOverride = _this$props.loadUsersOverride,
        loadRemainingPages = _this$props.loadRemainingPages,
        csvFetchingStatus = _this$props.csvFetchingStatus,
        formatCSVData = _this$props.formatCSVData,
        artifactType = _this$props.artifactType,
        artifactId = _this$props.artifactId,
        features = _this$props.features;
      var reportDownloadEnabled = features.includes(REPORT_DOWNLOAD_FF);
      var fetchCSVData = function fetchCSVData() {
        return loadRemainingPages(artifactType, artifactId, loadUsersOverride);
      };
      if (reportDownloadEnabled && !loading && hasAnyOutcomes && hasAnyStudents) {
        return jsx(ExportCSVButton, {
          fetchCSVData: fetchCSVData,
          formatCSVData: formatCSVData,
          fetchingStatus: csvFetchingStatus,
          artifactId: artifactId,
          focusedElement: focusedElement
        });
      }
    };
    return _this;
  }
  _createClass(OutcomesPerStudentReport, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props2 = this.props,
        artifactType = _this$props2.artifactType,
        artifactId = _this$props2.artifactId,
        loadPage = _this$props2.loadPage,
        setError = _this$props2.setError,
        loadUsersOverride = _this$props2.loadUsersOverride;
      loadPage(artifactType, artifactId, 1, loadUsersOverride).catch(function (e) {
        return setError(e);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.clearReportStore();
    }
  }, {
    key: "renderReportTable",
    value: function renderReportTable() {
      var _this2 = this;
      var headerIds = [];
      var _this$props3 = this.props,
        rollups = _this$props3.rollups,
        getReportOutcome = _this$props3.getReportOutcome,
        getScore = _this$props3.getScore,
        _viewReportAlignment = _this$props3.viewReportAlignment,
        isOpen = _this$props3.isOpen,
        closeReportAlignment = _this$props3.closeReportAlignment,
        users = _this$props3.users,
        showRollups = _this$props3.showRollups,
        scope = _this$props3.scope;
      return jsx("div", {
        css: this.props.styles.reportWrapper,
        "data-automation": "outcomesPerStudent__reportWrapper"
      }, jsx("div", {
        css: this.props.styles.table,
        role: "grid"
      }, jsx("div", {
        css: this.props.styles.headerRow,
        role: "row",
        "data-automation": "outcomesPerStudent__headerRow"
      }, renderCorner(rollups.length, this.props.styles), rollups.map(function (rollup, i) {
        headerIds[i] = shortid.generate(); // eslint-disable-line immutable/no-mutation
        return (
          // FIXME: use stable keys here
          jsx("div", {
            id: headerIds[i],
            key: headerIds[i],
            role: "columnheader",
            css: _this2.props.styles.headerCell,
            "data-automation": "outcomesPerStudent__headerCell"
          }, jsx(Header, {
            outcomeResult: rollup,
            getReportOutcome: getReportOutcome,
            viewReportAlignment: function viewReportAlignment() {
              return _viewReportAlignment(rollup.outcomeId);
            },
            isOpen: isOpen(rollup.outcomeId),
            closeReportAlignment: closeReportAlignment,
            showRollups: showRollups,
            scope: scope
          }))
        );
      })), jsx("div", {
        role: "row"
      }, jsx("div", {
        role: "rowheader"
      }, jsx(ScreenReaderContent, null, t('Details'))), rollups.map(function (rollup, i) {
        return (
          // FIXME: use stable keys here
          jsx("div", {
            key: headerIds[i],
            role: "gridcell"
          }, jsx(ScreenReaderContent, null, jsx(HeaderDetails, {
            outcomeResult: rollup,
            showRollups: showRollups
          })))
        );
      })), users.map(function (student) {
        var _renderStudentName = renderStudentName(student, _this2.props.styles),
          studentNameElement = _renderStudentName.studentNameElement;
        return jsx("div", {
          key: student.uuid,
          css: _this2.props.styles.studentRow,
          role: "row",
          "data-automation": "outcomesPerStudent__studentRow"
        }, studentNameElement, rollups.map(function (rollup, i) {
          return jsx("div", {
            key: rollup.outcomeId,
            css: _this2.props.styles.scoreCell,
            role: "gridcell",
            "data-automation": "outcomesPerStudent__scoreCell"
          }, jsx(Score, {
            score: getScore(rollup.outcomeId, student.uuid),
            outcome: getReportOutcome(rollup.outcomeId)
          }));
        }));
      })), renderPagination(this.props));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        users = _this$props4.users,
        hasAnyOutcomes = _this$props4.hasAnyOutcomes,
        loading = _this$props4.loading;
      var hasAnyStudents = users && users.length > 0;
      var focusedElement = document.activeElement;
      var renderReportContent = function renderReportContent() {
        if (loading) {
          return renderLoading(_this3.props.styles);
        } else if (!hasAnyOutcomes) {
          return renderBillboard(noOutcomes());
        } else if (!hasAnyStudents) {
          return renderBillboard(noStudents());
        } else {
          return _this3.renderReportTable();
        }
      };
      return jsx("div", {
        css: this.props.styles.background
      }, this.renderExportButton(hasAnyStudents, focusedElement), renderReportContent());
    }
  }]);
  OutcomesPerStudentReport.displayName = "OutcomesPerStudentReport";
  return OutcomesPerStudentReport;
}(React.Component), _class2.propTypes = {
  users: PropTypes.array.isRequired,
  artifactType: PropTypes.string.isRequired,
  artifactId: PropTypes.string.isRequired,
  rollups: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  loadRemainingPages: PropTypes.func.isRequired,
  csvFetchingStatus: PropTypes.string.isRequired,
  formatCSVData: PropTypes.func.isRequired,
  loadPage: PropTypes.func.isRequired,
  loadUsersOverride: PropTypes.func,
  setError: PropTypes.func.isRequired,
  showRollups: PropTypes.bool,
  getReportOutcome: PropTypes.func.isRequired,
  hasAnyOutcomes: PropTypes.bool.isRequired,
  getScore: PropTypes.func.isRequired,
  viewReportAlignment: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
  closeReportAlignment: PropTypes.func.isRequired,
  features: PropTypes.array.isRequired,
  clearReportStore: PropTypes.func.isRequired,
  scope: PropTypes.string.isRequired,
  styles: PropTypes.object
}, _class2.defaultProps = {
  loadUsersOverride: void 0,
  showRollups: true
}, _class2)) || _class);
export default OutcomesPerStudentReport;